<template>
  <section v-if="getSttServicePending">
    <p-loading />
  </section>
  <section v-else-if="getSttServiceFailed">
    <p-not-found />
  </section>
  <section v-else-if="sttService" class="edit-service">
    <p-edit :item="sttService" @submit="edit" />
    <div>
      <p-button v-if="$hasPermission('administration')" color="secondary" type="submit" @click="deleteSttService">DELETE</p-button>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex';
import EditForm from './_CreateOrEditStt';
import Loading from '@/components/common/Loading';
import Button from '@/components/common/Button';
import NotFound from '@/components/NotFound.vue';

export default {
  components: {
    'p-edit': EditForm,
    'p-loading': Loading,
    'p-button': Button,
    'p-not-found': NotFound
  },
  data() {
    return {
      sttService: null
    };
  },
  computed: {
    ...mapState({
      getSttServiceFailed: s => s.nlp.getSttServiceFailed,
      getSttServicePending: s => s.nlp.getSttServicePending,
      organizationsCollection: s => s.organizations.collection || []
    })
  },
  async created() {
    await this.$store.dispatch('organizations/getCollection');
    this.sttService = await this.$store.dispatch('nlp/getSttService', this.$route.params.id);
  },
  methods: {
    async edit(sttService) {
      try {
        await this.$store.dispatch('nlp/updateSttService', sttService);
        this.$router.push({ path: `/administration` });

        this.$toast.success({
          title: 'Updated',
          message: `Speech to text service '${sttService.name}' successfully updated`
        });
      } catch (error) {
        const { message } = JSON.parse(await error.response.text());
        this.$toast.error({
          title: 'Failed to update speech to text service',
          message: message
        });
      }
    },
    async deleteSttService() {
      const inUseOrgs = (this.organizationsCollection || []).filter(o => o.enableSpeechToText && o.speechToTextService?.id === this.sttService.id);

      if (inUseOrgs.length) {
        const namesList = inUseOrgs.map(o => o.name).join(', ');
        this.$toast.error({
          title: `Cannot delete '${this.sttService.name}' because it is in use`,
          message: `This service is currently assigned to: ${namesList}. Please update speech to text settings in the Organizations panel before deleting.`
        });
        return;
      }

      const confirmResult = await this.$confirm({
        title: 'Delete service?',
        message: `Are you sure you want to delete service '${this.sttService.name}'?`,
        confirm: 'Delete'
      });

      if (!confirmResult) {
        return;
      }
      try {
        await this.$store.dispatch('nlp/deleteSttService', this.sttService);
        this.$toast.success({
          title: 'Deleted',
          message: `Service '${this.sttService.name}' successfully deleted`
        });
        this.$router.push({ path: `/administration` });
      } catch (error) {
        const { message } = JSON.parse(await error.response.text());
        this.$toast.error({
          title: 'Failed to delete service',
          message: message
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.edit-service {
  display: grid;
  grid-gap: 0.5rem;
  grid-template-rows: minmax(0, 1fr);
  grid-template-columns: minmax(0, 2fr) minmax(0, 1fr);
  width: 100%;
  height: 100%;
  padding: 0 0.5rem 0 1rem;
}
</style>
